import React from 'react'

const STATS = [
  ['in_effect', 'in effect'],
  ['hard', 'hard'],
  ['compliance', 'compliance'],
  ['conditional_hard', 'conditional hard'],
  ['reduced_bid', 'reduced bid'],
  ['extra_document', 'extra doc'],
  ['soft', 'soft'],
  ['other', 'invalid action'],
  ['overridden_here', 'overridden here'],
]

export default function StatsStrip({ stats }) {
  return (
    <div className="lox-blocks-explorer__stats" data-testid="blocks-stats">
      {STATS.filter(([key]) => key === 'in_effect' || stats[key] > 0).map(
        ([key, label]) => (
          <span key={key} className="lox-blocks-explorer__stat">
            <strong>{stats[key]}</strong> {label}
          </span>
        )
      )}
    </div>
  )
}
